var exports = {
  "Os": "group-b0lNV",
  "$h": "closed-b0lNV",
  "Pl": "headline-b0lNV",
  "Qs": "content-b0lNV",
  "_Z": "labelImage-b0lNV",
  "Kk": "icon-b0lNV",
};

module.exports = exports;
